import React from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import { FaSun, FaMoon } from 'react-icons/fa';
import './DarkModeToggle.css';

const DarkModeToggle = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <div className="dark-mode-toggle-container">
      <button
        className={`dark-mode-toggle ${isDarkMode ? 'dark' : 'light'}`}
        onClick={toggleDarkMode}
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        <div className="toggle-track">
          <div className="toggle-thumb">
            {isDarkMode ? (
              <FaMoon className="toggle-icon moon-icon" />
            ) : (
              <FaSun className="toggle-icon sun-icon" />
            )}
          </div>
        </div>
        
        {/* Glow effect */}
        <div className="toggle-glow"></div>
        
        {/* Particle effects */}
        <div className="toggle-particles">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="particle" style={{ '--i': i }}></div>
          ))}
        </div>
      </button>
    </div>
  );
};

export default DarkModeToggle; 